/* eslint-disable react/prop-types */
import React from 'react';
import { getButtonTrack } from '../../helpers';
import LinkIcon from '../LinkIcon';

export function Link({ bordered = false, href = '#invalid', text, position }) {
  return (
    <div className="link" data-bordered={bordered} data-track={getButtonTrack({ position, pointsname: text })}>
      <a href={href}>
        <span>{text}</span> <LinkIcon />
      </a>
    </div>
  );
}
